import { render } from "./Question.vue?vue&type=template&id=4ae9ff4e&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=4ae9ff4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ae9ff4e"

export default script